function clamp(value, min, max) {
  return Math.max(min, Math.min(value, max));
}

function distance(x1, y1, x2, y2) {
  const a = x1 - x2;
  const b = y1 - y2;

  return Math.sqrt((a * a) + (b * b));
}

function midpoint(x1, y1, x2, y2) {
  return {
    x: (x1 + x2) * 0.5,
    y: (y1 + y2) * 0.5,
  };
}

export {
  clamp,
  distance,
  midpoint,
};



// WEBPACK FOOTER //
// ./src/syos/utils/math.js